module.exports = __webpack_public_path__ + "assets/tenbis_square-a9d819.svg";